import api from './client';

// Integrations - Pennylane API
export const pennylaneAPI = {
  getStatus: () => api.get('/integrations/pennylane/status'),
  getEntities: () => api.get('/integrations/pennylane/entities'),
  connect: (entityId, apiKey) => api.post('/integrations/pennylane/connect', { entity_id: entityId, api_key: apiKey }),
  disconnect: (entityId) => api.delete(`/integrations/pennylane/disconnect/${entityId}`),
  sync: () => api.post('/integrations/pennylane/sync'),
  syncReconciliation: () => api.post('/integrations/pennylane/sync-reconciliation'),
  getInvoices: (type = 'all', limit = 50) => api.get('/integrations/pennylane/invoices', { params: { invoice_type: type, limit } }),
  getSyncHistory: (limit = 10) => api.get('/integrations/pennylane/sync-history', { params: { limit } }),
};

// Pennylane bank feed (Phase 2): connection mapping, daily sync, feed status
export const pennylaneBankFeedAPI = {
  listMappings: () => api.get('/admin/pennylane-bankfeed/mappings'),
  listInternalAccounts: (entityId) =>
    api.get('/admin/pennylane-bankfeed/internal-accounts', { params: { entity_id: entityId || undefined } }),
  createMapping: (body) => api.post('/admin/pennylane-bankfeed/mappings', body),
  deactivateMapping: (mappingId) =>
    api.post(`/admin/pennylane-bankfeed/mappings/${mappingId}/deactivate`),
  runNow: (mappingId) =>
    api.post(`/admin/pennylane-bankfeed/mappings/${mappingId}/sync`, null, { timeout: 60000 }),
  listRuns: (mappingId, limit = 50) =>
    api.get('/admin/pennylane-bankfeed/runs', { params: { mapping_id: mappingId || undefined, limit } }),
};
